import type { ReactNode } from 'react';
import { cx } from './cx.ts';
import s from './MapParts.module.css';
import t from './type.module.css';

// The map's parts from the storyboards (S-05, W-01), approved in the D-4 review 2026-10-20.

/** What the lines on the map are, with today's distances. */
export function MapLegend({
  lines,
}: {
  lines: { label: string; detail?: string | undefined; color: string; dashed?: boolean }[];
}) {
  return (
    <ul className={s.legend} aria-label="Map legend">
      {lines.map((l) => (
        <li key={l.label}>
          <svg width="28" height="4" aria-hidden="true">
            <line
              x1="0"
              y1="2"
              x2="28"
              y2="2"
              stroke={l.color}
              strokeWidth="3"
              strokeDasharray={l.dashed ? '5 3' : undefined}
            />
          </svg>
          <span className={t.caption}>{[l.label, l.detail].filter(Boolean).join(' · ')}</span>
        </li>
      ))}
    </ul>
  );
}

/** The stop on now (or the one chosen), at the foot of the map. */
export function MapPlaceCard({
  stopId,
  state,
  meta,
  title,
  detail,
  photo,
  tags,
}: {
  stopId: string;
  state: string;
  meta?: string | undefined;
  title: string;
  detail?: string | undefined;
  photo?: string | null | undefined;
  tags?: ReactNode;
}) {
  return (
    <div className={s.card}>
      <div className={cx(s.head, t.label)}>
        <span>{[stopId, state].filter(Boolean).join(' · ')}</span>
        {meta && <span>{meta}</span>}
      </div>
      <div className={s.body}>
        {photo ? (
          <img className={s.photo} src={photo} alt="" />
        ) : (
          <span className={s.photo} aria-hidden="true" />
        )}
        <div className={s.text}>
          <div className={t.titleM}>{title}</div>
          {detail && <div className={cx(t.caption, s.muted)}>{detail}</div>}
          {tags && <div className={s.tags}>{tags}</div>}
        </div>
      </div>
    </div>
  );
}
